module.exports = __webpack_public_path__ + "media/images/supporters_lp/bg2-838318c657072aa785a61c455dee0685.png";